import axios from 'axios'
import Cookies from 'js-cookie'

const ADMIN_TOKEN_KEY = 'EDU_ADMIN_TOKEN'

// 创建管理端请求实例
const createAdminHttp = () => {
  const http = axios.create({
    baseURL: '/gateway',
    timeout: 60000
  })

  http.interceptors.request.use((config) => {
    const token = Cookies.get(ADMIN_TOKEN_KEY)
    if (token) {
      config.headers.token = token
    }
    return config
  })

  http.interceptors.response.use(
    (response) => {
      if (response.data.code === 200) {
        return Promise.resolve(response.data.data || response.data)
      } else {
        return Promise.reject(response.data)
      }
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  return http
}

const adminHttp = createAdminHttp()

// 管理员密码登录
export function adminLoginPwd(data) {
  return adminHttp.post('/base/api/manager/login/pwd', data)
}

// 管理员短信登录
export function adminLoginCode(data) {
  return adminHttp.post('/base/api/manager/login/verification/code', data)
}

// 管理员发送短信验证码
export function adminSendCode(data) {
  return adminHttp.post('/base/api/manager/send/verification/code', data)
}

// 管理员选择企业
export function adminChooseEnterprise(data) {
  return adminHttp.put('/base/admin/manager/current/choose/shop', data)
}

// 获取管理员当前企业列表
export function adminGetUserEnterpriseList() {
  return adminHttp.get('/base/admin/manager/current/shop/list')
}

// 获取管理员登录图片验证码
export function getCodeImg() {
  return adminHttp.get('/base/api/manager/get/image/verification')
}